import React from "react";
import { withTranslation } from "react-i18next";
import SvgContainer from "src/components/SvgContainer";
import { Flex, Box } from "@chakra-ui/react";
import { H3 } from "src/atoms/typography";

import Menu from "src/components/Menu";
import MenuItem from "src/components/Menu/Item";
import MenuItemText from "src/components/Menu/ItemText";
import CorrespondingAvatar from "src/modules/avatar/components/CorrespondingAvatar";
import { ReactComponent as ArrowDown } from "./down-small.svg";
import { DarkMode } from "src/styling/Modes";

class AvatarPicker extends React.Component {
  state = {
    isOpen: false
  };

  handleAvatarChange = (avatarId) => {
    this.props.onAvatarChange(avatarId);
    this.setState({ isOpen: false });
  };
  openPicker = () => this.setState({ isOpen: true });
  closePicker = () => this.setState({ isOpen: false });

  render() {
    const { isOpen } = this.state;
    const { selectedAvatar, restOfAvatars, t } = this.props;
    const avatarsList = [selectedAvatar, ...restOfAvatars];

    if (selectedAvatar == null)
      return (
        <H3 fontSize={["16px", "18px", "20px"]} color="white">
          {t("babyStation")}
        </H3>
      );

    const selectedAvatarView = (
      <Flex alignItems="center" minHeight="24px">
        <Box mr="8px">
          <CorrespondingAvatar
            avatar={selectedAvatar}
            width="20px"
            height="20px"
          />
        </Box>
        <H3
          fontSize={["16px", "18px", "20px"]}
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
          maxWidth="178px"
          color="white"
        >
          {selectedAvatar.name}
        </H3>
      </Flex>
    );

    if (restOfAvatars.length === 0) return selectedAvatarView;

    return (
      <>
        <DarkMode adjuster={(colors) => ({ surfaceElevated1: colors.black70 })}>
          <Menu
            isOpen={isOpen}
            onClose={this.closePicker}
            anchorEl={
              <Flex onClick={this.openPicker} alignItems="center">
                {selectedAvatarView}
                <SvgContainer icon={ArrowDown} fill="white" />
              </Flex>
            }
            maxHeight="250px"
            anchorOrigin={{
              vertical: "top",
              horizontal: "center"
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center"
            }}
          >
            {avatarsList.map((avatar) => (
              <MenuItem
                key={avatar.objectId}
                onClick={() => this.handleAvatarChange(avatar.objectId)}
              >
                <Box mr="16px">
                  <CorrespondingAvatar
                    avatar={avatar}
                    width="24px"
                    height="24px"
                  />
                </Box>
                <MenuItemText>{avatar.name}</MenuItemText>
              </MenuItem>
            ))}
          </Menu>
        </DarkMode>
      </>
    );
  }
}

export default withTranslation()(AvatarPicker);
